export default function UserPreference({ openModal, preferences, jobPreferences, lang }: any) {
  const getPreferenceName = (id: number) =>
    jobPreferences.find((i: any) => i.id == id)?.name || "-";

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Preferensi Pekerjaan" : "Job Preferences"}<span className="text-red-500">*</span></h3>
        <button
          onClick={() => openModal("preference")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      {/* chips */}
      <div className="flex flex-wrap gap-2">
        {preferences?.length > 0 ? (
          preferences.map((exp: any, idx: number) => (
            <span
              key={idx}
              className="px-4 py-1 rounded-full text-sm bg-blue-100 text-blue-700 border border-blue-300"
            >
              {getPreferenceName(exp.preferenceName)}
            </span>
          ))
        ) : (
          <p className="text-gray-400 text-sm">No preferences added</p>
        )}
      </div>
    </div>
  );
}
